import { render, staticRenderFns } from "./AiRequirementsAddedEdit.vue?vue&type=template&id=227f6ecd&scoped=true"
import script from "./AiRequirementsAddedEdit.vue?vue&type=script&lang=js"
export * from "./AiRequirementsAddedEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f6ecd",
  null
  
)

export default component.exports